import React from 'react';
import styled from 'styled-components';
import {FormattedMessage, FormattedHTMLMessage, injectIntl} from 'react-intl';
import NavigationButton from '../../Components/NavigationButton'
import Sizes from '../../Assets/Sizes';
import {connect} from 'react-redux'
import ContainerPage from "../ContainerPage";
import Rain from "../../Components/Rain";
import {BottomWrapper, CoreWrapper, TopWrapper} from "../../Components/Layout";
import H1 from "../../Components/H1";
import H2 from "../../Components/H2";
import Link from "../../Components/Link";
import {Analytics} from "../../Common/Analytics";
import {getSafely, isNonEmptyString} from "@tomeravni/easybizy-js-common/common";
import {resolveContextNameAndCustomerToken, resolvePath} from "../../Common/Helpers";

const MyBottomWrapper = styled(BottomWrapper)`
    z-index: 100;

    a {
        text-decoration: none;
    }
`;

const MyTopWrapper = styled(TopWrapper)`
    padding-left: ${Sizes.defaultPadding};
    padding-right: ${Sizes.defaultPadding};
    justify-content: space-evenly;
`;

const MyH2 = styled(H2)`
    font-weight: 500;
    max-width: 90%;
    text-align: center;
    display: inline-block;
`;

const FlexBottomWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: stretch;

    > * {
        width: 100%;
    }

    span {
        color: ${p => p.theme.colors.primaryText};
    }
`;

class Error extends ContainerPage {
    constructor(props) {
        super(props);
        /// This is important to prevent navigation to identify page.
        this.allowAnonymous = true;
    }

    componentDidMount() {
        super.componentDidMount();
        Analytics.track('error-loaded', {error: this.humanizeError || 'Unknown'});
    }

    render() {
        let telAttr;
        const businessPhoneNumber = getSafely(['BusinessPhoneNumber'], this.props.config);
        if (isNonEmptyString(businessPhoneNumber)) {
            telAttr = `tel: ${businessPhoneNumber}`;
        }

        const ltr = !this.props.intl.locale.includes('he');

        const {contextName, customerToken} = resolveContextNameAndCustomerToken(this.props.config, this.props.match);

        let restartEl;
        if (contextName) {
            const needsToReauthenticate = this.props.errorMessageType === 'CustomerNeedsToReAuthenticate';
            restartEl = <a href={resolvePath(contextName, needsToReauthenticate ? null : customerToken)}>
                <NavigationButton><FormattedMessage
                    id="restart"/></NavigationButton></a>
        }


        return (
            <div className="transition-item detail-page detail-page__error">
                <CoreWrapper ltr={ltr}>
                    <Rain/>

                    <MyTopWrapper>
                        <SloganWrapper>
                            <H1><FormattedHTMLMessage id="error.slogan"/></H1>
                        </SloganWrapper>
                        <SloganWrapper>
                            {!this.humanizeError && <H2><FormattedHTMLMessage id="error.message"/></H2>}
                            {this.humanizeError && <MyH2>{this.humanizeError}</MyH2>}
                        </SloganWrapper>
                    </MyTopWrapper>
                    <MyBottomWrapper>
                        <FlexBottomWrapper>
                            {restartEl || <a href="mailto:info@easybizy.net"> <NavigationButton><FormattedMessage
                                id="error.contact_us"/></NavigationButton></a>}
                            {telAttr && <NavigationButton><Link
                                custom-theme="shallow-button"
                                href={telAttr}><FormattedMessage
                                id="schedule.callUs"/></Link></NavigationButton>}
                        </FlexBottomWrapper>
                    </MyBottomWrapper>
                </CoreWrapper>
            </div>
        )
    }
}

/** Styled-Components **/

const SloganWrapper = styled.div`
    line-height: 1.5;
    font-size: ${Sizes.sloganTextSize};
    display: block;
    font-weight: bold;
    text-align: center;
`;

/** END OF Styled-Components **/


const mapStateToProps = state => {
    return {
        config: state.schedule.config,
        errorMessageType: getSafely(['schedule', 'errorWithConfig', 'message'], state)
    };
};

const mapDispatchToProps = dispatch => {
    return {}
};


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Error));
